import { EGender, EPartsLower, EPartsUpper } from '../../../types/fio';
import { MAX_SUGGEST_RESULTS } from '../constants';

export interface IGetFioRequestBodyProps {
  query: string;
  part: EPartsLower;
  gender: EGender;
}
export const getFioRequestBody = (props: IGetFioRequestBodyProps) => {
  const mapParts = {
    patronymic: EPartsUpper.Patronymic,
    name: EPartsUpper.Name,
    surname: EPartsUpper.Surname,
  };

  return JSON.stringify({
    query: props.query,
    gender: props.gender,
    parts: [mapParts[props.part]],
    count: MAX_SUGGEST_RESULTS,
  });
};
